<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    preserveAspectRatio="xMinYMin meet"
    class="icon"
  >
    <g>
      <path
        d="M7,2v46h36V2H7z M25,37H14c-0.552,0-1-0.448-1-1s0.448-1,1-1h11c0.552,0,1,0.448,1,1S25.552,37,25,37z M25,29H14 c-0.552,0-1-0.448-1-1s0.448-1,1-1h11c0.552,0,1,0.448,1,1S25.552,29,25,29z M25,21H14c-0.552,0-1-0.448-1-1s0.448-1,1-1h11 c0.552,0,1,0.448,1,1S25.552,21,25,21z M25,13H14c-0.552,0-1-0.448-1-1s0.448-1,1-1h11c0.552,0,1,0.448,1,1S25.552,13,25,13z M31,39 c0,0.552-0.448,1-1,1s-1-0.448-1-1V10c0-0.552,0.448-1,1-1s1,0.448,1,1V39z M36,37h-1c-0.552,0-1-0.448-1-1s0.448-1,1-1h1 c0.552,0,1,0.448,1,1S36.552,37,36,37z M36,29h-1c-0.552,0-1-0.448-1-1s0.448-1,1-1h1c0.552,0,1,0.448,1,1S36.552,29,36,29z M36,21 h-1c-0.552,0-1-0.448-1-1s0.448-1,1-1h1c0.552,0,1,0.448,1,1S36.552,21,36,21z M36,13h-1c-0.552,0-1-0.448-1-1s0.448-1,1-1h1 c0.552,0,1,0.448,1,1S36.552,13,36,13z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "list"
};
</script>
<style scoped>
.icon {
  fill: currentColor;
}
</style>
